OE.addPlugin('GA', (function(){

    var Plugin = {},
        window_has_ga = typeof window.ga !== 'undefined';

    Plugin.init = function()
    {
        provide_window_ga();
        donate_button_event();
        Plugin.trackPage();
    };

    var provide_window_ga = function()
    {
        if(!window_has_ga)
        {
            window.ga = function()
            {
                var eventCategory = typeof arguments[2] !== 'undefined' ? arguments[2] : null,
                    eventAction = typeof arguments[3] !== 'undefined' ? arguments[3] : null,
                    eventLabel = typeof arguments[4] !== 'undefined' ? arguments[4] : null,
                    eventValue = typeof arguments[5] !== 'undefined' ? arguments[5] : null;

                OE.Plugins.GA.trackEvent(eventCategory, eventAction, eventLabel, eventValue);
            };
        }
    };

    var trackDonateEventOnSubmit = function(e)
    {
        OE.Plugins.GA.trackEvent('Donate', 'Donate via PayPal', 'Donation Page');
    };

    var donate_button_event = function()
    {
        var donate_button = document.querySelectorAll('form input[value="_donations"]'),
            button_count = donate_button.length;

        for(var i = 0; i < button_count; i++)
        {
            var form = donate_button[i].form;
            form.addEventListener('submit', trackDonateEventOnSubmit);
        }
    };

    Plugin.trackEvent = function(eventCategory, eventAction, eventLabel, eventValue)
    {
        eventCategory = typeof eventCategory !== 'string' ? 'pageAction' : eventCategory;
        eventAction   = typeof eventAction !== 'string' ? eventCategory : eventAction;
        eventLabel    = typeof eventLabel !== 'string' ? eventAction : eventLabel;
        eventValue    = typeof eventValue === 'undefined' ? null : eventValue;

        var via = null;

        if(window.dataLayer)
        {
            window.dataLayer.push({
                event : eventAction,
                event_category : eventCategory,
                event_action : eventAction,
                event_label : eventLabel,
                event_value : eventValue
            });

            via = 'window.dataLayer';
        }
        else if(window_has_ga)
        {
            window.ga("send", "event", eventCategory, eventAction, eventLabel, eventValue);
            via = 'window.ga';
        }
        else if(window.__gaTracker)
        {
            window.__gaTracker("send", "event", eventCategory, eventAction, eventLabel, eventValue);
            via = 'window.__gaTracker';
        }
        else if(window._gaq)
        {
            window._gaq.push(["_trackEvent", eventCategory, eventAction, eventLabel]);
            via = 'window._gaq';
        }

        if(via)
        {
            console.log("\n****************\n" +
                "Tracked event via " + via + ":\n" +
                "\tCategory : " + eventCategory + "\n" +
                "\tAction :   " + eventAction + "\n" +
                "\tLabel :    " + eventLabel + "\n" +
                "\tValue :    " + eventValue
            );
        }
    };

    Plugin.trackPage = function()
    {
        var is_single = document.querySelector('body').classList.contains('single-post'),
            post_type = document.querySelector('body').getAttribute('class').match(/single-format-([a-z]+)/i),
            post_id = document.querySelector('body').getAttribute('class').match(/postid-(\d+)/i),
            post_title = '';

        if(is_single && post_type)
        {
            if(typeof(post_type[1]) !== 'undefined')
            {
                switch(post_type[1])
                {
                    case 'audio' :
                        post_type = 'podcast';
                        break;
                    case 'video' :
                        post_type = 'video';
                        break;
                    case 'standard' :
                        post_type = 'article';
                        break;
                    default :
                        post_type = null;
                        break;
                }

                if(post_type)
                {
                    if(typeof(post_id[1]) !== 'undefined')
                    {
                        post_id = post_id[1];
                        post_title = document.querySelector('.is--single.post-' + post_id + ' .post-header .post-title');
                        if(post_title)
                        {
                            post_title = post_title.textContent.trim() + ' (Post #' + post_id + ')';
                        }
                        else
                        {
                            post_title = 'Post #' + post_id;
                        }
                    }
                    post_title = post_title.replace(/ {2,}/,' ');

                    Plugin.trackEvent('mediatype', post_type, post_title);
                }
            }
        }
    };

    Plugin.getVideoTracker = function(el)
    {
        if(!el.player && window.track_event)
        {
            return null;
        }

        var element = el;
        var player = element.player;
        var player_type = element.classList.contains('is--vimeo') ? 'Vimeo' : (element.classList.contains('is--youtube') ? 'YouTube' : 'Video');
        var player_position = 0;
        var player_url = element.getAttribute('href');

        var trackPlay = function()
        {
            if(player_type === 'Vimeo')
            {
                player.getCurrentTime().then( function(seconds) {
                    player_position = seconds;

                    player.getVideoUrl().then( function(url) {
                        player_url = url;

                        track('Played');
                    });
                });
            }
            else if(player_type === 'YouTube')
            {
                player_position = player.getCurrentTime();
                player_url = player.getVideoUrl();
                track('Played');
            }
            else
            {
                track('Played');
            }
        };

        var track = function(type)
        {
            if(typeof type === 'string')
            {
                switch(type)
                {
                    case "Played" :
                        type = Math.round(player_position) > 0 ? 'Resumed' : 'Started';
                        break;
                }

                Plugin.trackEvent(player_type, type + " video", player_url, undefined, true);
            }
        };


        return {
            play : function()
            {
                if(player_type === 'Vimeo')
                {
                    player.getCurrentTime().then( function(seconds) {
                        player_position = seconds;

                        player.getVideoUrl().then( function(url) {
                            player_url = url;

                            track('Played');
                        });
                    });
                }
                else if(player_type === 'YouTube')
                {
                    player_position = player.getCurrentTime();
                    player_url = player.getVideoUrl();
                    track('Played');
                }
                else
                {
                    track('Played');
                }
            },
            pause : function()
            {
                if(player_type === 'Vimeo')
                {
                    player.getVideoUrl().then( function(url) {
                        player_url = url;
                        track('Paused');
                    });
                }
                else if(player_type === 'YouTube')
                {
                    player_url = player.getVideoUrl();
                    track('Paused');
                }
                else
                {
                    track('Paused');
                }
            },
            end : function()
            {
                if(player_type === 'Vimeo')
                {
                    player.getVideoUrl().then( function(url) {
                        player_url = url;
                        track('Completed');
                    });
                }
                else if(player_type === 'YouTube')
                {
                    player_url = player.getVideoUrl();
                    track('Completed');
                }
                else
                {
                    track('Completed');
                }
            }
        };
    };

    return Plugin;
})());
